import script from "./ElevateAnalyticsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ElevateAnalyticsPage.vue?vue&type=script&setup=true&lang=ts"

import "./ElevateAnalyticsPage.vue?vue&type=style&index=0&id=2567a539&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2567a539"]])

export default __exports__